import { useTranslation } from 'react-i18next';

const avatarUrls = [
  "https://readdy.ai/api/search-image?query=Professional%20clean%20modern%20portrait%20style%20avatar%20young%20adult%20minimal%20studio%20lighting%20neutral%20expression%20simple%20cream%20background%20headshot%20photography&width=96&height=96&seq=avatar-v2-01&orientation=squarish",
  "https://readdy.ai/api/search-image?query=Friendly%20warm%20portrait%20style%20avatar%20person%20smiling%20softly%20clean%20studio%20lighting%20natural%20expression%20simple%20cream%20background%20headshot%20minimal%20professional%20photography&width=96&height=96&seq=avatar-v2-02&orientation=squarish",
  "https://readdy.ai/api/search-image?query=Confident%20modern%20portrait%20style%20avatar%20adult%20professional%20clean%20studio%20lighting%20gentle%20smile%20simple%20cream%20background%20headshot%20minimal%20photography%20neutral%20expression&width=96&height=96&seq=avatar-v2-03&orientation=squarish",
];

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative h-screen w-full overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Soft%20warm%20pastel%20product%20flatlay%20with%20sneakers%20hoodies%20accessories%20on%20light%20cream%20textured%20background%20clean%20aesthetic%20editorial%20photography%20minimal%20composition%20with%20gentle%20natural%20shadows%20warm%20neutral%20tones%20lifestyle%20product%20photography%20scandinavian%20style%20diverse%20fashion%20items%20arranged%20artistically&width=1600&height=900&seq=hero-bg-v2&orientation=landscape"
        alt="Oopbuy Spreadsheet Shopping"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/40 via-black/15 to-transparent"></div>

      <div className="relative z-10 h-full flex flex-col justify-center px-4 md:px-8 lg:px-20">
        <div className="max-w-2xl">
          <div className="flex items-center gap-3 mb-6">
            <div className="flex -space-x-4">
              {avatarUrls.map((url, i) => (
                <div key={i} className="w-12 h-12 rounded-full border-2 border-white overflow-hidden">
                  <img src={url} alt="" className="w-full h-full object-cover" />
                </div>
              ))}
            </div>
            <span className="text-white text-sm md:text-base font-medium">{t('hero.users')}</span>
          </div>

          <h1 className="text-white mb-8">
            <span className="block text-[56px] md:text-[80px] font-extrabold leading-[0.95]">{t('hero.title1')}</span>
            <span className="block text-[40px] md:text-[64px] font-light leading-[0.95] mt-1">{t('hero.title2')}</span>
          </h1>

          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 h-14 px-8 rounded-full bg-white text-foreground-900 text-base font-semibold hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              {t('nav.cta1')}
              <span className="w-10 h-10 rounded-full bg-foreground-950 flex items-center justify-center">
                <i className="ri-arrow-right-line text-white text-base"></i>
              </span>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 h-14 px-8 rounded-full border-2 border-white/60 text-white text-base font-semibold hover:bg-white/10 transition-colors whitespace-nowrap cursor-pointer"
            >
              {t('nav.cta2')}
              <i className="ri-shopping-bag-line"></i>
            </a>
          </div>
        </div>

        <div className="absolute right-8 md:right-20 bottom-[120px] max-w-[420px]">
          <p className="text-white/90 text-lg leading-relaxed font-light">
            {t('hero.subtitle')}
          </p>
        </div>
      </div>
    </section>
  );
}